export default __webpack_public_path__ + "static/media/ontime-mssii.cbc872c9.svg";